document.addEventListener('DOMContentLoaded', function () {
    const faqQuestions = document.querySelectorAll('.faq-question');

    faqQuestions.forEach(function (question) {
        question.addEventListener('click', function () {
            const answer = this.nextElementSibling;

            if (answer && answer.classList.contains('faq-answer')) {
                answer.style.display =
                    answer.style.display === 'none' || answer.style.display === ''
                        ? 'block'
                        : 'none';
            }
        });
    });
});

const bulletContainers = document.querySelectorAll(".bullet_point, .pbpoint-list");

bulletContainers.forEach((container) => {

    const items = container.matches(".bullet_point")
        ? container.querySelectorAll("p")
        : container.querySelectorAll("li");

    if (items.length > 3) {

        // Hide after 3 items
        items.forEach((item, index) => {

            if (index > 2) {
                item.style.display = "none";
            }

        });

        // Create button
        const moreBtn = document.createElement("a");

        moreBtn.href = "#";
        moreBtn.innerText = "More Benefits";
        moreBtn.classList.add("bullet_point_more");

        container.after(moreBtn);

        // Click Event
        moreBtn.addEventListener("click", function (e) {

            e.preventDefault();

            items.forEach((item) => {

                if (container.matches(".bullet_point")) {
                    item.style.display = "flex";
                } else {
                    item.style.display = "list-item";
                }

            });

            moreBtn.remove();

        });

    }

});

// const bulletPoint = document.querySelector(".bullet_point");
// const bulletPointItem = document.querySelectorAll(".bullet_point p");

// if (bulletPointItem.length > 3) {

//     // Hide items after 3
//     bulletPointItem.forEach((item, index) => {

//         if (index > 2) {
//             item.style.display = "none";
//         }

//     });

//     // Create Read More button
//     const bulletPointMore = document.createElement("a");

//     bulletPointMore.href = "#";
//     bulletPointMore.innerText = "More Benefits";
//     bulletPointMore.classList.add("bullet_point_more");

//     // Add button after grid
//     bulletPoint.after(bulletPointMore);

//     // Click Event
//     bulletPointMore.addEventListener("click", function (e) {

//         e.preventDefault();

//         bulletPointItem.forEach((item) => {
//             item.style.display = "flex";
//         });

//         bulletPointMore.remove();

//     });

// }